import '../assets/scss/main.scss';
import '../assets/scss/print.scss';

// only load "above the fold" components that are relevant on every page, such as navigation (with logo and icons) and cookie consent

// cleanup icon caches before loading any icon components
import '../features/cleanupIconCache.ts';

// keep cookie consent first, so that it has absolute priority in rendering
import '../features/cookieConsentI18n.ts';
import '../features/cookieConsentOnPageLoad.ts';

// yet it appears above the fold and must be available immediately to avoid jumps.
import '@bjb/bjb-web-components/dist/components/jb-campaign-teaser/jb-campaign-teaser.js';
import '@bjb/bjb-web-components/dist/components/jb-breadcrumbs/jb-breadcrumbs.js';
import '@bjb/bjb-web-components/dist/components/jb-contact-overlay/jb-contact-overlay.js';
import '@bjb/bjb-web-components/dist/components/jb-cta-small/jb-cta-small.js';
import '@bjb/bjb-web-components/dist/components/jb-focus-fly/jb-focus-fly.js';
import '@bjb/bjb-web-components/dist/components/jb-info-page-hero/jb-info-page-hero.js';
import '@bjb/bjb-web-components/dist/components/jb-language-alert/jb-language-alert.js';
import '@bjb/bjb-web-components/dist/components/jb-listing-grid/jb-listing-grid.js';
import '@bjb/bjb-web-components/dist/components/jb-logo/jb-logo.js';
import '@bjb/bjb-web-components/dist/components/jb-navigation/jb-navigation.js';
import '@bjb/bjb-web-components/dist/components/jb-news-overlay/jb-news-overlay.js';
import '@bjb/bjb-web-components/dist/components/jb-region-indicator/jb-region-indicator.js';
import '@bjb/bjb-web-components/dist/components/jb-headline-with-text/jb-headline-with-text.js';
import '@bjb/bjb-web-components/dist/components/jb-richtext/jb-richtext.js';
import '@bjb/bjb-web-components/dist/components/jb-service-navigation/jb-service-navigation.js';
import '@bjb/bjb-web-components/dist/components/jb-simple-page-hero/jb-simple-page-hero.js';
import '@bjb/bjb-web-components/dist/components/jb-teaser-block/jb-teaser-block';
import '@bjb/bjb-web-components/dist/components/jb-text-teaser/jb-text-teaser';

import '../features/addFocusFly.ts';
import '../features/addLocationTrackingData.ts';
import '../features/adobeTrackingSettings.ts';
import '../features/alerts.ts';
import '../features/article-page/openNewsletterRegistration.ts';
import '../features/bypassBlock.ts';
import '../features/detectInternalUsers.ts';
import '../features/disclaimer.ts';
import '../features/eServiceOverlayCountry.ts';
import '../features/fetchMenu.ts';
import '../features/handleAnchorScroll.ts';
import '../features/handleTrackingEvents.ts';
import '../features/marketSpecificArticleCards.ts';
import '../features/marketSpecificLinks.ts';
import '../features/infoBoxCountryCondition.ts';
import '../features/languageAlert.ts';
import '../features/loadTrackingOnConsent.ts';
import '../features/openContactOverlay.ts';
import '../features/openNewsOverlayDeepLink.ts';
import '../features/popupsAboveOverlay.ts';
import '../features/regionSelectOverlay.ts';
import '../features/saveCampaignData.ts';
import '../features/saveReferrerData.ts';
import '../features/saveWaypointHistory.ts';
import '../features/submitPrivacyPreferences.ts';
import '../features/trackConsent.ts';
import '../features/trackPrivacy.ts';
import '../features/videoCaptionsLanguage.ts';

import '../legacy/main';

import('./main_lazy');
